module.exports = __webpack_public_path__ + "zvetseni-prsou_7_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-prsou_7_before.jpg
// module id = 1368
// module chunks = 0